import { defaultBaseBackgroundRenderContribution } from "./base-contribution-render";

import { DefaultAreaTextureRenderContribution } from "./area-texture-contribution-render";

export const defaultAreaTextureRenderContribution = new DefaultAreaTextureRenderContribution;

export const defaultAreaBackgroundRenderContribution = defaultBaseBackgroundRenderContribution;
//# sourceMappingURL=area-contribution-render.js.map
